import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiInfo, FiShare2 } from "react-icons/fi";
import logoPedidos from "../../Imagenes/arrow_left_dark.svg";
import imgLoader from "../Imagenes/Pedidos.jpg";
import botonFlotante from "../../Imagenes/ico_menu_while.svg";

import RadioInputSeleccion from "../DetalleProducto/RadioInputSeleccion";
import "./DetalleAlternativo.css";
import { useParams } from "react-router-dom"; // lo importo al componente al cual quiero ir o enviar datos
import { Header } from "../../componentes/header/Header";
import { apiGet } from '../../utils/api';
import { FaArrowLeft } from "react-icons/fa";
import { configShop } from '../../states/configShop';
export const DetalleAlternativo = ({ codigoCurrency, codigoPais }) => {
  const { dataConfig } = configShop();
  // console.log("company_logo detalle alternativo: ");
  // console.log(company_logo);

  const [infoProductoSeleccionado, setinfoProductoSeleccionado] = useState([]);
  const { uuid, name, description, price, units, toppings_groups, tags } =
    infoProductoSeleccionado; // desestructuracion desde el api en este mismo componente

  const [infoPropiedades, setInfoPropiedades] = useState([]);
  const { color_botton, color_hover } = infoPropiedades;

  const [cantidadProducto, setCantidadProducto] = useState(1);
  const [precioTotal, setPrecioTotal] = useState(price);
  const [toppingsSeleccionados, setToppingsSeleccionados] = useState([]); // este viene de RadioInputSeleccion.

  const [photo, setPhoto] = useState(imgLoader);
  const [descuento, setDescuento] = useState({});
  const { colors } = descuento;
  const { idDetalleAlternativo } = useParams(); // uuid del plato seleccionado
  const [propiedadesCompany, setPropiedadesCompany] = useState([]);
  const apiDetalle = '';
  useEffect(() => {
    var typeSend = localStorage.getItem("typeSend");
    (async function () {
      const res = await apiGet(`/item-detail/${idDetalleAlternativo}`);
      setPhoto(res.data.photo);
      setinfoProductoSeleccionado(res.data);
      setInfoPropiedades(res.properties);
      setDescuento(res.data.discount);
      setPropiedadesCompany(res.properties);
    })();
  }, [apiDetalle]);
  /////
  const [copied, setCopied] = useState(false);
  const handleShare = async () => {
    const url = window.location.href; // URL actual
    if (navigator.share) {
      try {
        await navigator.share({
          title: name,
          text: dataConfig?.description_home,
          url: url,
        });
        console.log("Compartido con éxito");
      } catch (error) {
        console.log("Error al compartir:", error);
      }
    } else if (navigator.clipboard) {
      // Fallback: copiar al portapapeles
      navigator.clipboard.writeText(url).then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // mensaje temporal
      });
    } else {
      alert("Tu navegador no soporta compartir");
    }
  };

  ////////
  const agregarInfoLocalStorage = () => {
    // crear el json
    const productoSeleccionado = {
      idPlatoSelec: uuid,
      nombrePlatoSelec: name,
      descripcionPlatoSelec: description,
      fotoPlatoSelec: photo,
      precio: price,
      cantidadProducto: cantidadProducto,
      toppings: toppingsSeleccionados,
    };
    // se esta obteniendo la informacion del localStorage en caso de que haya algo de informacion. //
    const informacionLocalStorage = localStorage.getItem(
      "infoProductoSeleccionado"
    );

    if (
      informacionLocalStorage === undefined ||
      informacionLocalStorage === null
    ) {
      var listaProductos = [productoSeleccionado];
      localStorage.setItem(
        "infoProductoSeleccionado",
        JSON.stringify(listaProductos)
      );
    } else {
      let parsedRespuesta = JSON.parse(informacionLocalStorage); // JSON.parse convierte la información de string a un objeto de javascript.
      var listaProductos = [...parsedRespuesta, productoSeleccionado];

      localStorage.setItem(
        "infoProductoSeleccionado",
        JSON.stringify(listaProductos)
      );
    }
  };

  let navigate = useNavigate();
  const validacionCantidad = (e) => {
    if (cantidadProducto !== undefined) {
      var productoSePuedeGuardarCarrito = true;

      var statusObligatorio = true;
      var pendienteName;
      var cantidadMinima;

      if (toppings_groups !== undefined) {
        const newState = toppings_groups.map((item) => {
          if (item.type === 0) {
            productoSePuedeGuardarCarrito = false;
            if (statusObligatorio === true) {
              let filtro = toppingsSeleccionados.filter(
                (categoria) => categoria.uuid === item.uuid
              );

              var categoriaGuardada = filtro[0];
              if (item.cant_min === 0) {
                productoSePuedeGuardarCarrito = true;
              } else {
                if (categoriaGuardada !== undefined) {
                  if (
                    categoriaGuardada.topingsSeleccionados.length >=
                    item.cant_min
                  ) {
                    productoSePuedeGuardarCarrito = true;
                  } else {
                    statusObligatorio = false;
                    pendienteName = item.name;
                    cantidadMinima = item.cant_min;
                  }
                } else {
                  statusObligatorio = false;
                  pendienteName = item.name;
                  cantidadMinima = item.cant_min;
                }
              }
            }
          }
        });
      }
      if (productoSePuedeGuardarCarrito === true) {
        agregarInfoLocalStorage();
        window.history.back()
      } else {
        alert(
          "Te faltan toppings por seleccionar en " +
          pendienteName +
          ", cantidad mínima: " +
          cantidadMinima
        );
      }
    }
  };

  var toppingsGuardados = [];
  const guardarToppingsSeleccionados = (toppings) => {
    toppingsGuardados = toppings;
    totalProductos(cantidadProducto);
    setToppingsSeleccionados(toppings);
  };

  const sumarProducto = () => {
    if (cantidadProducto > 0) {
      var suma = cantidadProducto + 1;
      setCantidadProducto(suma);
      totalProductos(suma);
    }
  };

  const restarProducto = () => {
    if (cantidadProducto > 1) {
      var resta = cantidadProducto - 1;
      setCantidadProducto(resta);
      totalProductos(resta);
    }
  };

  const totalProductos = (cantidadProducto) => {
    if (toppingsGuardados.length === 0) {
      // el array toppingsGuardados esta vacio.
      // Si esta vacio entonces lo actualiza con la informacion que tiene en el set toppingsSeleccionados
      toppingsGuardados = toppingsSeleccionados;
    }

    var sumaToppings = 0;
    if (toppingsGuardados !== undefined) {
      toppingsGuardados.map((item) => {
        if (item !== undefined) {
          item.topingsSeleccionados.map((topping) => {
            sumaToppings = sumaToppings + topping.price;
          });
        }
      });
    }
    var resultado = (parseInt(price) + sumaToppings) * cantidadProducto;
    setPrecioTotal(resultado);
  };

  return (
    <React.Fragment key={uuid}>
      <div className="container-principal" key={uuid}>
        <div className="encabezado-comida-alternativo">
          <div className="espacio-elementos">
            <div className="texto-encabezado-detalle">
              <Link
                to="javascript:void(0)"
                onClick={() => window.history.back()}
              >
                <FaArrowLeft color={dataConfig?.page_menu?.button?.color ?? "#000"} size={24} />
              </Link>
            </div>

            {(() => {
              if (price !== undefined) {
                return (
                  <p key={price} className="precio-alternativo  color-text" style={{ "--btn-font-color": dataConfig?.page_menu?.color_price }}>
                    {" "}
                    {price.toLocaleString(codigoPais, {
                      style: "currency",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                      currency: codigoCurrency,
                    })}{" "}
                  </p>
                );
              }
            })()}

            {(() => {
              if (descuento.status === true) {
                if (descuento.value !== undefined) {
                  return (
                    <>
                      <p
                        key={descuento.value}
                        className="precio-tachado-rojo-foto-1"
                      >
                        {" "}
                        {descuento.value.toLocaleString(codigoPais, {
                          style: "currency",
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 0,
                          currency: codigoCurrency,
                        })}{" "}
                      </p>
                    </>
                  );
                }
              }
            })()}
          </div>

          {(() => {
            if (descuento.status === true) {
              return (
                <p
                  key={descuento.labels}
                  className="porcentaje-descuento-detalle-2"
                  style={{ background: `${descuento.colors}` }}
                >
                  {" "}
                  {descuento.labels}{" "}
                </p>
              );
            }
          })()}

          <div className="grupo-etiquetas-alternativo">
            {(() => {
              if (tags !== undefined) {
                return tags.map((item) => {
                  return (
                    <p
                      key={item.label}
                      className="etiqueta-texto-3"
                      style={{ background: `${item.colors}` }}
                    >
                      {" "}
                      {item.label}{" "}
                    </p>
                  );
                });
              }
            })()}
          </div>
        </div>

        <div className="container-imagen-cabecera-alternativo">
          {(() => {
            if (photo !== "") {
              return (
                <img
                  src={photo}
                  alt="imagenCabecera"
                  className="imgEncabezado"
                  style={{
                    width: "auto",
                    height: "100%",
                    borderRadius: "0px 0px 25px 25px",
                  }}
                ></img>
              );
            } else {
              return (
                <img
                  src={imgLoader}
                  alt="imagenCabecera"
                  className="imgEncabezado"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "0px 0px 25px 25px",
                  }}
                ></img>
              );
            }
          })()}
        </div>

        <section className="container-options-detalle-alternativo ">
          <div className="container-titulo">
            <h3 key={name} id={name}
              className="title-v2"
              style={{ "--btn-font-color": dataConfig?.page_menu?.color_text }}
            >
              {name} 
            </h3>
             <FiShare2 onClick={() => handleShare()} color={dataConfig?.page_menu?.color_text} size={25} className="mx-1" />
          </div>

          <div className="container-info">
            <p key={description} id={description} className="parrafo">
              {description}
            </p>
          </div>

          {(() => {
            if (toppings_groups !== undefined) {
              return (
                <RadioInputSeleccion
                  tituloTopping={toppings_groups}
                  codigoCurrency={codigoCurrency}
                  codigoPais={codigoPais}
                  guardarToppingsSeleccionados={guardarToppingsSeleccionados}
                  color_botton={color_botton}
                  color_hover={color_hover}
                />
              );
            }
          })()}
        </section>
        {localStorage?.getItem("typeSend") < 2 && (
          <div style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#fff",
            borderRadius: "20px 20px 0 0",
            boxShadow: "0 -4px 20px rgba(0,0,0,0.10)",
            padding: "14px 16px 22px",
            zIndex: 100,
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}>
            {/* Selector de cantidad */}
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              border: `2px solid ${dataConfig?.page_menu?.button?.color ?? "#000"}`,
              borderRadius: "12px",
              padding: "8px 14px",
              flexShrink: 0,
            }}>
              <span
                onClick={restarProducto}
                style={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: dataConfig?.page_menu?.button?.color ?? "#000",
                  cursor: "pointer",
                  lineHeight: 1,
                  userSelect: "none",
                }}
              >−</span>
              <span style={{ fontSize: "18px", fontWeight: 700, minWidth: "20px", textAlign: "center" }}>
                {cantidadProducto}
              </span>
              <span
                onClick={sumarProducto}
                style={{
                  fontSize: "22px",
                  fontWeight: 700,
                  color: dataConfig?.page_menu?.button?.color ?? "#000",
                  cursor: "pointer",
                  lineHeight: 1,
                  userSelect: "none",
                }}
              >+</span>
            </div>

            {/* Botón agregar con precio */}
            <button
              onClick={() => validacionCantidad()}
              style={{
                flex: 1,
                background: dataConfig?.page_menu?.button?.color ?? "#000",
                color: dataConfig?.page_menu?.button?.color_text ?? "#fff",
                border: "none",
                borderRadius: "12px",
                padding: "14px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
                boxShadow: "0 4px 14px rgba(0,0,0,0.18)",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: 700 }}>Agregar al pedido</span>
              <span style={{ fontSize: "16px", fontWeight: 700 }}>
                {(precioTotal ?? price)?.toLocaleString(codigoPais, {
                  style: "currency",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                  currency: codigoCurrency,
                })}
              </span>
            </button>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
